import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Route, Switch, useParams, withRouter } from "react-router-dom";
import { _get } from "../Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import DashboardSideMenu from "../components/DashboardSideMenu/DashboardSideMenu";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import * as cloudActions from "../store/CloudActions";
import { getFilteredMerchants, getMerchantFromServer, setUserProfiles, setUserRoles } from "../store/CloudActions";
import { ToastContainer } from "react-toastify";
import { getProfilesFromMerchant } from "../authorization/authorizations";
import { getRoutes } from "../utils/routes/Routes";
import OppInvoicesMasterMerchant from "../components/OppInvoices/OppInvoicesMasterMerchant";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    width: "100%",
  },
  content: {
    marginTop: 56,
    flexGrow: 1,
    overflow: "scroll",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  docked: {
    width: 0,
  },
}));

export const smallScreenBoundary = 620;

function Dashboard() {
  const classes = useStyles();
  const [navigationRows, setNavigationRows] = React.useState(null);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [merchant, setMerchant] = React.useState(null);

  let { merchantId } = useParams();
  merchantId = parseInt(merchantId);

  if (!cloudStore.userRoles) {
    const sessionRoles = JSON.parse(sessionStorage.getItem("roles"));
    if (!sessionRoles || sessionRoles.length === 0) {
      _get("/nova/api/roles")
        .then((res) => {
          let roles = [];
          res.data.data.roles.forEach((role) => {
            roles.push(role.name);
          });
          sessionStorage.setItem("roles", JSON.stringify(roles));
          setUserRoles(roles);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      sessionStorage.setItem("roles", JSON.stringify(sessionRoles));
      setUserRoles(sessionRoles);
    }
  }

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED, onChange);
    if (cloudStore.merchants === null) {
      getFilteredMerchants();
    } else {
      setNavigationRows(cloudStore.filteredMerchants);
    }
    return () => {
      cloudStore.removeListener(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED, onChange);
    };
  }, []);

  function onChange() {
    setNavigationRows(cloudStore.filteredMerchants);
  }

  if (navigationRows) {
    const index = navigationRows.findIndex((e) => e.merchant_id === merchantId);
    if (index !== currentIndex && index !== -1) {
      setCurrentIndex(index);
    }
  }

  if (navigationRows === null || cloudStore.merchant?.id !== merchantId || !merchant) {
    if (navigationRows && !isNaN(merchantId)) {
      getMerchantFromServer(merchantId).then((merchant) => {
        setMerchant(merchant);
      });
    }

    if (!isNaN(merchantId)) {
      return (
        <div align="center">
          <CircularProgress color="primary" />
        </div>
      );
    }
  }
  const routes = getRoutes(
    merchantId,
    merchant?.ta_merchants ?? [],
    merchant?.sp_merchants ?? [],
    merchant?.pillar_merchants ?? []
  );

  return (
    <div className={classes.root}>
      <CssBaseline />

      <DashboardSideMenu navigationRows={navigationRows} routes={routes} />

      <main className={classes.content}>
        <Container className={classes.container} maxWidth={"xl"}>
          <Switch>
            {routes.reduce((routes, link) => {
              if (link.subLinks) {
                routes = routes.concat(
                  link.subLinks.map((link) => {
                    return <Route path={link.path} component={link.component} key={link.getLink()} />;
                  })
                );
              } else {
                routes.push(<Route path={link.path} component={link.component} key={link.getLink()} />);
              }
              return routes;
            }, [])}
            <Route
              path={"/home/:merchantId/opp_master_merchants/:oppMasterMerchantId"}
              component={OppInvoicesMasterMerchant}
              key={"opp_master_merchant_invoices"}
            />
          </Switch>
        </Container>
      </main>
    </div>
  );
}

export default withRouter(Dashboard);
